// extracted by mini-css-extract-plugin
export default {"operator_avatar_container":"styles_operator_avatar_container__czAix","operator_avatar_container__name":"styles_operator_avatar_container__name__uGfwV"};